import MeasuredOrderVirtualList from '@/pages/orders/components/MeasuredOrderVirtualList';
import OrderCard from '@/shared-components/cards/components/OrderCard';

import './styles/VirtualList.css';

export default function VirtualList({ fetchData, loadMoreData }) {
  return (
    <MeasuredOrderVirtualList
      orders={fetchData.data}
      totalOrders={fetchData.totalDocs}
      loadMoreData={loadMoreData}
      defaultRowHeight={244}
      renderOrder={(order) => <OrderCard orderData={order} navigateToView/>}
    />
  );
}
